// Material Kit 2 React pages
import WestCoast from "pages/LandingPages/Locations/WestCoast";

export default function WestCoastPage() {
  return <WestCoast />;
}
